import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function Years(props) {
  const {
    startYear, endYear, startShift, yearWidth,
  } = props;
  const years = [];
  for (let y = startYear; y <= endYear; y += 1) {
    years.push(y);
  }

  return (
    <div style={{
      display: 'flex',
      position: 'relative',
      left: `${startShift}px`,
    }}
    >
      {years.map(year => [
        <Typography
          variant="body1"
          key={year}
          style={{
            fontWeight: year % 10 === 0 ? 'bold' : 'normal',
            fontSize: year % 10 === 0 ? '1em' : '0.75em',
            transform: 'translate(-50%, 0)',
            width: `${yearWidth}px`,
            flexShrink: 0,
          }}
        >
          {year}
        </Typography>,
        <div
          key={`d${year}`}
          style={{
            width: '1px',
            height: '3px',
            backgroundColor: 'gray',
            transform: 'translate(-50%, 0)',
            position: 'absolute',
            left: `${(year - years[0]) * yearWidth}px`,
          }}
        />,
      ])}
    </div>
  );
}

Years.propTypes = {
  yearWidth: PropTypes.number.isRequired,
  startYear: PropTypes.number.isRequired,
  endYear: PropTypes.number.isRequired,
  startShift: PropTypes.number,
};

Years.defaultProps = {
  startShift: 0,
};



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/Years.jsx